import {resources} from "../../../../models/resource/resources";

export const defectsModalName = 'defects';

export const productCardsDefectsResourceType = resources['product-cards-defects'];
export const productCardsDefectValuesResourceType = resources['product-cards-defect-values'];
export const feedbacksResourceType = resources['feedbacks'];
